import fetch from "auth/FetchInterceptor";

export const CustomerService = {};

CustomerService.get = async ({ page, pageSize, sort, searchText }) => {
  let apiUrl = "/v1/customer?page=" + page + "&per_page=" + pageSize;
  if (sort === "ascend") apiUrl += "&order_by=%2Dname";
  else if (sort === "descend") apiUrl += "&order_by=%2Bname";
  if (searchText) apiUrl += "&name=" + searchText;
  return fetch({
    url: apiUrl,
    method: "get",
  });
};

CustomerService.getById = async (id) => {
  const apiUrl = `/v2/customer/${id}`;
  return fetch({
    url: apiUrl,
    method: "get",
  });
};

CustomerService.createCustomer = async (data) => {
  const apiUrl = `/v1/customer`;
  return fetch({
    url: apiUrl,
    method: "post",
    data: data,
  });
};

CustomerService.updateCustomer = async (data) => {
  const apiUrl = `/v2/customer/${data.id}`;
  return fetch({
    url: apiUrl,
    method: "put",
    data: data,
  });
};

CustomerService.getAddresses = async (customerId) => {
  return fetch({
    url: `/v1/customer/${customerId}/address`,
    method: "get",
  });
};

CustomerService.createAddress = async (customerId, data) => {
  return fetch({
    url: `/v1/customer/${customerId}/address`,
    method: "post",
    data,
  });
};

CustomerService.updateAddress = async (customerId, addressId, data) => {
  return fetch({
    url: `/v1/customer/${customerId}/address/${addressId}`,
    method: "put",
    data,
  });
};

CustomerService.deleteAddress = async (customerId, addressId) => {
  return fetch({
    url: `/v1/customer/${customerId}/address/${addressId}`,
    method: "delete",
  });
};

export default CustomerService;
